export default __webpack_public_path__ + "assets/873d1f.svg";